import React, { createContext, useContext } from 'react';
import { createPortal } from 'react-dom';

/**
 * Holds the persistent banner DOM node (rendered once by DashboardLayout) so that
 * individual pages can portal their own banner content into it without forcing
 * DashboardLayout itself to re-render on every navigation.
 */
export const BannerPortalContext = createContext<HTMLDivElement | null>(null);

/**
 * Renders `content` into the shared banner slot via a portal.
 * Returns null (and renders nothing) until the banner target is mounted or no content is given.
 */
export function useBannerContent(content: React.ReactNode): React.ReactPortal | null {
  const target = useContext(BannerPortalContext);
  if (!target || !content) return null;
  return createPortal(content, target);
}
